import ListSelected from './ListSelected';

export default ListSelected;